import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        // main
        {
            path: '/main',
            name: 'main',
            component: () => import('@/pages/main.vue')
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js